import React from "react";
import "./TitleText.scss";

const env = window.__env__ || {};
const siteShortName = env.REACT_APP_SITE_SHORT_NAME || process.env.REACT_APP_SITE_SHORT_NAME || "RobTheDeveloper";

const titleMap = {
  RobTheDeveloper: "Rob The Developer",
  LiveOrDevTrying: "LiveOrDevTrying",
};

class TitleText extends React.Component {
  fadeOut = () => {
    document.getElementById("title-block").classList.add("title-fade-in");
    document.getElementById("title-block").classList.add("title-fade-out");
  };
  fadeIn = () => {
    document.getElementById("title-block").classList.remove("title-fade-out");
  };
  siteTitle = () => {
    return (
      <div className="title-block-content">
        <hr className="decorator" />
        <div className="title-content">{titleMap[siteShortName] || siteShortName}</div>
        <hr className="decorator" />
      </div>
    );
  };
  isLoading = () => {
    if (this.props.loading) {
      return (
        <div className="title-block-content">
          <div className="title-content">Is Loading</div>
        </div>
      );
    } else {
      return (
        <div className="title-block-content">
          <div className="title-content title-fade-out">Is Loading</div>
        </div>
      );
    }
  };
  render = () => {
    return (
      <div id="title-block" className="title-fade-in-initial">
        {this.siteTitle()}
        {this.isLoading()}
      </div>
    );
  };
}
export default TitleText;
